<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    icon="map-marked-alt"
    :items="filteredSubcounties"
    :loading="loading"
    @search="onSearch"
    @focus="onFocus"
    @input="$emit('input', $event)"
    v-on="$listeners"
  >
    <template #empty>
      {{ $t("conductor.common.noResults") }}
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref } from "@nuxtjs/composition-api";
import { useSubcountyActions } from "~/components/_refactored/conductor/subcounties/useSubcountyActions";

export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
  },
  setup(_props, { emit }) {
    const { getSubcounties } = useSubcountyActions();
    const filteredSubcounties = ref([]);
    const loading = ref(false);

    const onSearch = async (search) => {
      loading.value = true;
      const { items } = await getSubcounties({
        search,
        page: 1,
        pageSize: 15,
      });
      filteredSubcounties.value = items;
      loading.value = false;
    };

    const onFocus = (search) => {
      onSearch(search ?? "");
      emit("focus", search);
    };

    return {
      filteredSubcounties,
      onSearch,
      onFocus,
      loading,
    };
  },
};
</script>
